<div [class]="'bg-' + color" [ngStyle]="{ height, width }">
  <div [class]="'fill-' + color" [ngStyle]="{ height: '100%', width: value + '%' }"></div>
</div>